import { useNavigate } from 'react-router-dom';
import { BinaryQuestionTemplate } from '@templates';
import { useState } from 'react';
import { ErrorMessages } from '@types';
import { booleanSchema, parseZodErrors } from '@utils';
import { ZodError } from 'zod';
import { reportTypeQuestionData } from '@animal-nuisance/constants/questionData';
import { RoutesList } from '@animal-nuisance/routes/Routes';
import { isBinaryOptionDefault } from '@shared/utils';
import { BinaryOptionType } from '@shared/types';
import { useAnimalNuisanceStore } from '@animal-nuisance/hooks/useAnimalNuisanceStore';

export const ReportTypePage = () => {
  const navigate = useNavigate();
  const {
    data: { isStrayDog },
    update,
  } = useAnimalNuisanceStore();
  const [errorMessages, setErrorMessages] = useState<ErrorMessages[]>([]);
  const questionData = reportTypeQuestionData;
  const errorText = 'Select an option to continue.';

  const options = questionData.options.map((option) => ({
    ...option,
    id: option.labelText,
    name: option.labelText,
    isLabelBold: false,
    isDefault: isBinaryOptionDefault(
      option.labelText as BinaryOptionType,
      isStrayDog,
    ),
  }));

  const handleChange = (result: string) => {
    setErrorMessages([]);
    update('isStrayDog', result === 'Yes');
  };

  const handleNext = async () => {
    try {
      const validatedData = booleanSchema(questionData.key, errorText).parse({
        [questionData.key]: isStrayDog,
      });
      update('isStrayDog', validatedData[questionData.key]);
      if (validatedData[questionData.key] === false) {
        navigate(RoutesList.ISSUE_TYPE);
      } else {
        navigate(RoutesList.CALL_US);
      }
    } catch (error) {
      if (error instanceof ZodError) {
        const validationErrors = parseZodErrors(error as ZodError);
        setErrorMessages(
          validationErrors.map((error) => ({
            message: errorText,
            path: error.path,
          })),
        );
      } else {
        setErrorMessages([
          {
            message: (error as Error).message,
            path: questionData.key,
          },
        ]);
      }
    }
  };

  const buttonNext = {
    onClick: handleNext,
  };

  const buttonPrevious = {
    onClick: () => {
      navigate(RoutesList.BEFORE_YOU_START);
    },
  };

  return (
    <BinaryQuestionTemplate
      title={questionData.title}
      description={questionData.description}
      errorPath={questionData.key}
      errorMessages={errorMessages}
      options={options}
      onChange={handleChange}
      buttonNext={buttonNext}
      buttonPrevious={buttonPrevious}
    />
  );
};
